import { useEffect } from "react";
import { VegaEmbed } from "react-vega";
import "./WidgetBoard.scss";
import CancelIcon from "../../assets/images/CancelIcon";
import { useCustomDashboardStore } from "../../stores/customDashboardStore";

type WidgetBoardProps = {
  negotiationId: number;
  pageName: string;
};

const WidgetBoard = ({ negotiationId, pageName }: WidgetBoardProps) => {
  const {
    widgets,
    widgetsLoading,
    widgetsError,
    loadWidgets: fetchWidgets,
    removeWidget,
  } = useCustomDashboardStore();

  useEffect(() => {
    fetchWidgets(negotiationId, pageName);
  }, [negotiationId, pageName, fetchWidgets]);

  if (widgetsLoading) {
    return <div className="widget-board__placeholder">Loading widgets…</div>;
  }

  if (widgetsError) {
    return <div className="widget-board__placeholder error">{widgetsError}</div>;
  }

  if (!widgets.length) {
    return <div className="widget-board__placeholder">No Widgets Added.</div>;
  }

  return (
    <div className="widget-board">
      {widgets.map((widget) => (
        <div className="widget-board__card" key={widget.negotiation_report_chart_id}>
          <div className="widget-board__card-header">
            <div>
              {widget.chart_description && (
                <div className="widget-board__description">{widget.chart_description}</div>
              )}
            </div>
            <button
              className="widget-board__remove"
              onClick={() => removeWidget(widget.negotiation_report_chart_id)}
            >
              <CancelIcon />
            </button>
          </div>
          <div className="widget-board__body">
            <VegaEmbed
              spec={{
                ...widget.chart_vegajson,
                title: undefined, // suppress title overlay
                width: "container",
                autosize: { type: "fit", contains: "padding", resize: true },
              }}
              options={{
                actions: { export: true, source: true, compiled: false, editor: false },
              }}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default WidgetBoard;
